export default __webpack_public_path__ + "static/media/logo_sm.1a49201b.png";